import { Show } from "solid-js";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { RecipeForm } from "@/features/recipes/components/recipe-form";
import { RecipeDetailCarousel } from "@/features/recipes/components/recipe-detail-carousel";
import { PageContainer } from "@fleet/ui";
import { AppErrorBoundary } from "@/components/error-boundary";

function RecipeDetailPage() {
  const params = useParams({ from: "/_app/recipes/$recipeId" });
  return (
    <PageContainer maxWidth="3xl">
      <AppErrorBoundary variant="page" region="recipe-detail">
        <RecipeDetailCarousel recipeId={params().recipeId}>
          {/* Keyed so swiping/navigating to a sibling recipe remounts the form,
              re-hydrating it from the new recipe instead of keeping stale state. */}
          <Show when={params().recipeId} keyed>
            {(recipeId) => <RecipeForm recipeId={recipeId} />}
          </Show>
        </RecipeDetailCarousel>
      </AppErrorBoundary>
    </PageContainer>
  );
}

export const recipeDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/recipes/$recipeId",
  component: RecipeDetailPage,
});
